// Гарда для проверки на модель
export const isModel = (obj) => {
    return obj instanceof Model;
};
/**
 * Базовая модель, чтобы можно было отличить ее от простых объектов с данными
 */
export class Model {
    // Конструктор модели, принимает частичные данные и интерфейс событий
    constructor(data, events) {
        this.events = events;
        // Присваивание данных модели
        Object.assign(this, data);
    }
    // Метод для оповещения об изменениях в модели
    emitChanges(event, payload) {
        // Эмитирование события с возможностью передать данные
        this.events.emit(event, payload !== null && payload !== void 0 ? payload : {});
    }
}
